module.exports = __webpack_public_path__ + "static/logo2-56ab4f140447598416c4585032b8cbbc.png";